import {get} from "lodash";

export const MAX_SELECTED_SQUADS_IN_GROUP = 4;

export const MAX_SQUADS_IN_GROUP_STAGE = 32;

export const MAX_PREDICTIONS = 47;

export interface IOpponent {
	rank: number;
	stageName: string;
}

export interface IGridItem {
	bracketId: number;
	opponent1: IOpponent;
	opponent2: IOpponent;
	rightPosition?: boolean;
}

export interface IMatchInfo {
	bracketId: number
	datetimeStartsAt: string
	location: string
}

export interface IKnockoutMatchInfo {
	R16: IMatchInfo[];
	QF: IMatchInfo[];
	SF: IMatchInfo[];
	F: IMatchInfo[];
}

export interface IKnockoutGrid {
	R16: IGridItem[];
	QF: IGridItem[];
	SF: IGridItem[];
	F: IGridItem[];
}

export const knockoutGrid: IKnockoutGrid = {
	R16: [
		{
			bracketId: 1,
			opponent1: {
				rank: 1,
				stageName: "a",
			},
			opponent2: {
				rank: 2,
				stageName: "b",
			},
		},
		{
			bracketId: 3,
			opponent1: {
				rank: 1,
				stageName: "c",
			},
			opponent2: {
				rank: 2,
				stageName: "d",
			},
		},
		{
			bracketId: 5,
			opponent1: {
				rank: 1,
				stageName: "e",
			},
			opponent2: {
				rank: 2,
				stageName: "f",
			},
		},
		{
			bracketId: 7,
			opponent1: {
				rank: 1,
				stageName: "g",
			},
			opponent2: {
				rank: 2,
				stageName: "h",
			},
		},
		{
			bracketId: 2,
			opponent1: {
				rank: 1,
				stageName: "b",
			},
			opponent2: {
				rank: 2,
				stageName: "a",
			},
		},
		{
			bracketId: 4,
			opponent1: {
				rank: 1,
				stageName: "d",
			},
			opponent2: {
				rank: 2,
				stageName: "c",
			},
		},
		{
			bracketId: 6,
			opponent1: {
				rank: 1,
				stageName: "f",
			},
			opponent2: {
				rank: 2,
				stageName: "e",
			},
		},
		{
			bracketId: 8,
			opponent1: {
				rank: 1,
				stageName: "h",
			},
			opponent2: {
				rank: 2,
				stageName: "g",
			},
		},
	],
	QF: [
		{
			bracketId: 1,
			opponent1: {
				rank: 1,
				stageName: "R16",
			},
			opponent2: {
				rank: 3,
				stageName: "R16",
			},
		},
		{
			bracketId: 3,
			opponent1: {
				rank: 5,
				stageName: "R16",
			},
			opponent2: {
				rank: 7,
				stageName: "R16",
			},
		},
		{
			bracketId: 2,
			opponent1: {
				rank: 2,
				stageName: "R16",
			},
			opponent2: {
				rank: 4,
				stageName: "R16",
			},
		},
		{
			bracketId: 4,
			opponent1: {
				rank: 6,
				stageName: "R16",
			},
			opponent2: {
				rank: 8,
				stageName: "R16",
			},
		},
	],
	SF: [
		{
			bracketId: 1,
			opponent1: {
				rank: 1,
				stageName: "QF",
			},
			opponent2: {
				rank: 3,
				stageName: "QF",
			},
		},
		{
			bracketId: 2,
			opponent1: {
				rank: 2,
				stageName: "QF",
			},
			opponent2: {
				rank: 4,
				stageName: "QF",
			},
		},
	],
	F: [
		{
			bracketId: 1,
			opponent1: {
				rank: 1,
				stageName: "SF",
			},
			opponent2: {
				rank: 2,
				stageName: "SF",
			},
		},
	],
};

export const getCountItemsInKnockoutByStage = (stage: string) => {
	const items = get(knockoutGrid, stage, []) as IGridItem[];
	return items.length;
};

export const IS_LIVE_BRACKET_ENABLED = process.env.REACT_APP_IS_LIVE_BRACKET_ENABLED === 'true' || false;
